import React, { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { formatRM } from '../lib/format';

// Angka RM dengan animasi count-up
export default function AnimatedMoney({ value, className = '', duration = 700, testid }) {
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(reduce ? Number(value || 0) : 0);
  const raf = useRef();

  useEffect(() => {
    const target = Number(value || 0);
    if (reduce) { setDisplay(target); return; }
    const start = performance.now();
    const from = 0;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(from + (target - from) * eased);
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [value, duration, reduce]);

  return (
    <span className={`tabular font-mono ${className}`} data-testid={testid}>
      {formatRM(display)}
    </span>
  );
}
